import React from 'react'
import QuestionnaireForm from './QuestionnaireForm';
import NavBar from '../Welcome/NavBar';

const QuestionsHolder = () => {
  return (
    <div className="full-form">
      {" "}
      <NavBar className="container-fluid" />
      <div className="app-container">
        <div className="content ">
          {/* Header */}
          <div className="header">
            <div className="header-content">
              <div className="logo-container">
                <svg viewBox="0 0 24 24" fill="none" className="logo-icon">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M8 12l3 3 6-6"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <div>
                <h1 className="title">AI Family Match</h1>
                <p className="subtitle">
                  Reuniting Families Through Technology
                </p>
              </div>
            </div>
          </div>

          {/* Stats section */}
          {/* <div className="stats-section">
            <div className="stat-card">
              <h2 className="stat-number">6,472</h2>
              <p className="stat-label">Families Reunited</p>
            </div>
            <div className="stat-card">
              <h2 className="stat-number">6,472</h2>
              <p className="stat-label">Families Reunited</p>
            </div>
            <div className="stat-card">
              <h2 className="stat-number">6,472</h2>
              <p className="stat-label">Families Reunited</p>
            </div>
          </div> */}

          {/* How it works section */}
          <div className="how-it-works">
            <div className="how-it-works-content">
              <div className="icon-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="info-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="section-title">How It Works</h3>
                <p className="section-text">
                  Our AI technology analyzes your answers and cross-references
                  them with our database records to find
                  potential family matches. The more detailed your answers, the
                  higher the chance of finding a match.
                </p>
              </div>
            </div>
          </div>

          {/* Questionnaire form */}
          <QuestionnaireForm />
        </div>
      </div>
    </div>
  );
}

export default QuestionsHolder
